module.exports = __webpack_public_path__ + "static/img/20W-1.578f29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/06/20W-1.png
// module id = bSVB
// module chunks = 2